// import { useEffect, useMemo, useState } from 'react'
// import {
//   Alert,
//   Box,
//   Button,
//   Divider,
//   LinearProgress,
//   InputAdornment,
//   MenuItem,
//   Snackbar,
//   TextField,
//   ToggleButton,
//   ToggleButtonGroup,
//   Typography,
// } from '@mui/material'
// import SearchIcon from '@mui/icons-material/Search'
// import AddIcon from '@mui/icons-material/Add'
// import ViewKanbanOutlinedIcon from '@mui/icons-material/ViewKanbanOutlined'
// import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted'
// import TaskBoard from './Taskboard.tsx'
// import TaskList from './tasklist.tsx'
// import UserAvatar from './Useravtar.tsx'
// import TaskDetailDialog from './TaskDetailDialog.tsx'
// import CreateTaskDialog, { type NewTaskInput } from './CreateTaskDialog.tsx'
// import {
//   CURRENT_USER_ID,
//   PRIMARY,
//   PRIORITIES,
//   STATUSES,
//   STATUS_BY_ID,
//   USERS,
//   applyPatch,
//   defaultStatusId,
//   isFinalStatus,
//   CHECKLIST_KEY,
//   DETAIL_KEYS,
//   STATUS_KEYS,
//   deleteTodoTask,
//   saveTaskChecklist,
//   saveTaskDetails,
//   saveTaskStatus,
//   loadStatuses,
//   loadUsers,
//   moveTask,
//   loadTask,
//   loadTasks,
//   type Priority,
//   type StatusId,
//   type TaskPatch,
//   type TodoTask,
// } from './Tododata.ts'

// type View = 'board' | 'list'

// interface Filters {
//   q: string
//   assignee: 'all' | string
//   status: 'all' | StatusId
//   priority: 'all' | Priority
//   label: 'all' | string
// }

// const selectSx = { minWidth: 170, bgcolor: '#fff' }

// function ToDo() {
//   const [view, setView] = useState<View>('board')
//   const [tasks, setTasks] = useState<TodoTask[]>([])
//   const [filters, setFilters] = useState<Filters>({ q: '', assignee: 'all', status: 'all', priority: 'all', label: 'all' })
//   const [openTaskId, setOpenTaskId] = useState<string | null>(null)
//   const [createStatus, setCreateStatus] = useState<StatusId | null>(null) // non-null = create dialog open
//   const [toast, setToast] = useState<string | null>(null)
//   const [toastSev, setToastSev] = useState<'success' | 'error'>('success')
//   const [saving, setSaving] = useState(0) // number of saves in flight
//   const [ready, setReady] = useState(false) // users + statuses loaded from the API

//   useEffect(() => {
//     Promise.all([loadUsers(), loadStatuses()])
//       .then(() => loadTasks())
//       .then((list) => {
//         setTasks(list)
//         setReady(true)
//       })
//   }, [])

//   const setFilter = <K extends keyof Filters>(key: K, value: Filters[K]) => setFilters((f) => ({ ...f, [key]: value }))

//   const labels = useMemo(() => Array.from(new Set(tasks.flatMap((t) => t.labels))).sort(), [tasks])

//   const filtered = useMemo(() => {
//     const q = filters.q.trim().toLowerCase()
//     return tasks.filter(
//       (t) =>
//         (!q || t.title.toLowerCase().includes(q) || t.key.toLowerCase().includes(q)) &&
//         (filters.assignee === 'all' || t.assigneeId === filters.assignee) &&
//         (filters.status === 'all' || t.status === filters.status) &&
//         (filters.priority === 'all' || t.priority === filters.priority) &&
//         (filters.label === 'all' || t.labels.includes(filters.label)),
//     )
//   }, [tasks, filters])

//   const openCount = tasks.filter((t) => !isFinalStatus(t.status) && !!STATUS_BY_ID[t.status]).length
//   const doneCount = tasks.filter((t) => isFinalStatus(t.status)).length
//   const openTask = tasks.find((t) => t.id === openTaskId) ?? null

//   // --- mutations (swap these for API calls later; each one maps to one endpoint) ---

//   const notify = (msg: string, sev: 'success' | 'error' = 'success') => {
//     setToastSev(sev)
//     setToast(msg)
//   }

//   /**
//    * Save one task through the APIs its changed fields need (details, status, checklist).
//    * Resolves with the task as the server now has it, fetched by todoTaskId (not the whole list).
//    * Throws if any call fails, so nothing changes on screen.
//    */
//   const saveOne = async (old: TodoTask, next: TodoTask, patch: TaskPatch): Promise<TodoTask> => {
//     const touches = (keys: (keyof TaskPatch)[]) => keys.some((k) => k in patch)
//     const calls: Promise<unknown>[] = []
//     if (touches(DETAIL_KEYS)) calls.push(saveTaskDetails(next))
//     if (touches(STATUS_KEYS)) calls.push(saveTaskStatus(next))
//     if (CHECKLIST_KEY in patch) calls.push(saveTaskChecklist(old, next))
//     if (calls.length === 0) return next // comments and labels have no API yet: local only
//     await Promise.all(calls)
//     const fresh = await loadTask(old.id)
//     // activity is loaded by the detail dialog from the activity API, so it is not read here
//     return fresh ? { ...fresh, activity: next.activity, labels: next.labels } : next
//   }

//   /**
//    * Every edit lands here (detail dialog, list status select, board moves).
//    * The screen only changes after the API says it worked. Resolves true when everything saved.
//    */
//   const updateTasks = async (ids: string[], patch: TaskPatch): Promise<boolean> => {
//     const before = tasks.filter((t) => ids.includes(t.id))
//     // Changing the assignee is saved as a status change to REASSIGNED
//     const reassignedId = STATUS_BY_ID['reassigned'] ? 'reassigned' : null
//     const after = before.map((t) => {
//       const p = { ...patch }
//       if (p.assigneeId && p.assigneeId !== t.assigneeId && !p.status && reassignedId) p.status = reassignedId
//       return applyPatch(t, p, CURRENT_USER_ID)
//     })
//     const effective: TaskPatch = after.some((t, i) => t.status !== before[i].status) ? { ...patch, status: after[0].status } : patch

//     setSaving((n) => n + 1)
//     const results = await Promise.allSettled(before.map((old, i) => saveOne(old, after[i], effective)))
//     setSaving((n) => n - 1)

//     const saved = results.flatMap((r) => (r.status === 'fulfilled' ? [r.value] : []))
//     if (saved.length > 0) setTasks((prev) => prev.map((t) => saved.find((s) => s.id === t.id) ?? t))

//     const failed = results.find((r) => r.status === 'rejected') as PromiseRejectedResult | undefined
//     if (failed) {
//       notify(failed.reason?.response?.data?.message || failed.reason?.message || 'Could not save the change', 'error')
//       return false
//     }
//     if (ids.length > 1) notify(`Updated ${ids.length} tasks`)
//     return true
//   }

//   /** Board drag and drop: a new column is saved first, then the card moves; reordering in a column is local. */
//   const moveCard = async (id: string, to: string, beforeId: string | null) => {
//     const old = tasks.find((t) => t.id === id)
//     if (!old) return
//     if (old.status === to) {
//       setTasks((prev) => moveTask(prev, id, to, beforeId, CURRENT_USER_ID))
//       return
//     }
//     if (!(await updateTasks([id], { status: to }))) return
//     // saved: put the card where it was dropped
//     setTasks((prev) => {
//       const card = prev.find((t) => t.id === id)
//       if (!card) return prev
//       const rest = prev.filter((t) => t.id !== id)
//       const at = beforeId ? rest.findIndex((t) => t.id === beforeId) : -1
//       return at < 0 ? [...rest, card] : [...rest.slice(0, at), card, ...rest.slice(at)]
//     })
//   }

//   const deleteTask = async (id: string) => {
//     const t = tasks.find((x) => x.id === id)
//     if (!t) return
//     try {
//       await deleteTodoTask(t)
//       setTasks((prev) => prev.filter((x) => x.id !== id))
//       setOpenTaskId(null)
//       notify(`${t.key} deleted`)
//     } catch (error: any) {
//       notify(error?.response?.data?.message || error?.message || 'Could not delete the task', 'error')
//     }
//   }

//   /** The dialog has already saved the task through the API: reload the list so it shows up. */
//   const createTask = async (_input: NewTaskInput, createAnother: boolean) => {
//     setTasks(await loadTasks())
//     notify('Task created')
//     if (!createAnother) setCreateStatus(null)
//   }

//   const handleOpen = (task: TodoTask) => setOpenTaskId(task.id)
//   const handleCreate = (status: StatusId = defaultStatusId()) => setCreateStatus(status)

//   // if (!ready) return <Box className="p-3 m-3">Loading…</Box>
//   if (!ready) return <></>

//   return (
//     <Box sx={{ borderRadius: '10px' }} className="p-3 m-3 bg-white">
//       <Typography variant="h3" className="text-center" sx={{ fontWeight: 300 }}>
//         Team Tasks
//       </Typography>
//       <Typography className="text-center" sx={{ mt: 1, fontSize: 14, color: '#666' }}>
//         {openCount} open · {doneCount} closed
//       </Typography>
//       <Divider className="mt-3" sx={{ borderColor: PRIMARY }} />

//       {saving > 0 && <LinearProgress aria-label="Saving" sx={{ mt: 1, bgcolor: '#E6E3D3', '& .MuiLinearProgress-bar': { bgcolor: PRIMARY } }} />}

//       {/* Toolbar */}
//       <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2, my: 3 }}>
//         <TextField
//           size="small"
//           placeholder="Search tasks"
//           value={filters.q}
//           onChange={(e) => setFilter('q', e.target.value)}
//           sx={{ width: 260, bgcolor: '#fff' }}
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position="start">
//                 <SearchIcon fontSize="small" />
//               </InputAdornment>
//             ),
//           }}
//         />

//         {/* Users: dropdown select */}
//         <TextField select size="small" label="Assignee" value={filters.assignee} onChange={(e) => setFilter('assignee', e.target.value)} sx={selectSx}>
//           <MenuItem value="all">Everyone</MenuItem>
//           {USERS.map((u) => (
//             <MenuItem key={u.id} value={u.id}>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                 <UserAvatar user={u} size={22} />
//                 {u.name}
//               </Box>
//             </MenuItem>
//           ))}
//         </TextField>

//         {view === 'list' && (
//           <TextField select size="small" label="Status" value={filters.status} onChange={(e) => setFilter('status', e.target.value as Filters['status'])} sx={selectSx}>
//             <MenuItem value="all">All statuses</MenuItem>
//             {STATUSES.map((s) => (
//               <MenuItem key={s.id} value={s.id}>
//                 {s.label}
//               </MenuItem>
//             ))}
//           </TextField>
//         )}

//         <TextField select size="small" label="Priority" value={filters.priority} onChange={(e) => setFilter('priority', e.target.value as Filters['priority'])} sx={selectSx}>
//           <MenuItem value="all">All priorities</MenuItem>
//           {(Object.keys(PRIORITIES) as Priority[]).map((p) => (
//             <MenuItem key={p} value={p}>
//               {PRIORITIES[p].label}
//             </MenuItem>
//           ))}
//         </TextField>

//         {/* {view === 'board' && (
//           <TextField select size="small" label="Label" value={filters.label} onChange={(e) => setFilter('label', e.target.value)} sx={selectSx}>
//             <MenuItem value="all">All labels</MenuItem>
//             {labels.map((l) => (
//               <MenuItem key={l} value={l}>
//                 {l}
//               </MenuItem>
//             ))}
//           </TextField>
//         )} */}

//         <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center', gap: 1.5 }}>
//           <ToggleButtonGroup
//             exclusive
//             size="small"
//             value={view}
//             onChange={(_, v: View | null) => v && setView(v)}
//             aria-label="View"
//             sx={{ bgcolor: '#55533C2A', '& .MuiToggleButton-root': { textTransform: 'none', border: 0, px: 1.5, gap: 0.75, color: '#55533C' }, '& .Mui-selected': { bgcolor: '#55533C !important', fontWeight: 700, color: '#fff !important' } }}
//           >
//             <ToggleButton value="board">
//               <ViewKanbanOutlinedIcon fontSize="small" /> Board
//             </ToggleButton>
//             <ToggleButton value="list">
//               <FormatListBulletedIcon fontSize="small" /> List
//             </ToggleButton>
//           </ToggleButtonGroup>
//           <Button
//             variant="contained"
//             startIcon={<AddIcon />}
//             onClick={() => handleCreate()}
//             sx={{ bgcolor: PRIMARY, textTransform: 'none', fontWeight: 700, height: 40, '&:hover': { bgcolor: '#5C5A3B' } }}
//           >
//             New task
//           </Button>
//         </Box>
//       </Box>

//       {view === 'board' ? (
//         <TaskBoard
//           tasks={filtered}
//           onMove={moveCard}
//           onOpen={handleOpen}
//           onCreate={handleCreate}
//         />
//       ) : (
//         <TaskList tasks={filtered} onUpdate={updateTasks} onOpen={handleOpen} />
//       )}

//       {/* Task detail */}
//       {openTask && (
//         <TaskDetailDialog
//           key={openTask.id}
//           task={openTask}
//           labelOptions={labels}
//           onClose={() => setOpenTaskId(null)}
//           onUpdate={(patch) => updateTasks([openTask.id], patch)}
//           onDelete={() => deleteTask(openTask.id)}
//         />
//       )}

//       {/* Create task */}
//       {createStatus && (
//         <CreateTaskDialog
//           defaultStatus={createStatus}
//           labelOptions={labels}
//           onClose={() => setCreateStatus(null)}
//           onSubmit={createTask}
//         />
//       )}

//       <Snackbar open={!!toast} autoHideDuration={3000} onClose={() => setToast(null)} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
//         <Alert onClose={() => setToast(null)} severity={toastSev} variant="filled" sx={toastSev === 'success' ? { bgcolor: '#5C5A3B' } : undefined}>
//           {toast}
//         </Alert>
//       </Snackbar>
//     </Box>
//   )
// }

// export default ToDo
import { useEffect, useMemo, useState } from 'react'
import {
  Alert,
  Box,
  Button,
  Divider,
  LinearProgress,
  InputAdornment,
  MenuItem,
  Snackbar,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import AddIcon from '@mui/icons-material/Add'
import ViewKanbanOutlinedIcon from '@mui/icons-material/ViewKanbanOutlined'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted'
import TaskBoard from './Taskboard.tsx'
import TaskList from './tasklist.tsx'
import UserAvatar from './Useravtar.tsx'
import TaskDetailDialog from './TaskDetailDialog.tsx'
import CreateTaskDialog, { type NewTaskInput } from './CreateTaskDialog.tsx'
import {
  CURRENT_USER_ID,
  PRIMARY,
  PRIORITIES,
  STATUSES,
  STATUS_BY_ID,
  USERS,
  applyPatch,
  assigneesChanged,
  defaultStatusId,
  isFinalStatus,
  CHECKLIST_KEY,
  DETAIL_KEYS,
  STATUS_KEYS,
  deleteTodoTask,
  saveTaskChecklist,
  saveTaskDetails,
  saveTaskStatus,
  loadStatuses,
  loadUsers,
  moveTask,
  loadTask,
  loadTasks,
  type Priority,
  type StatusId,
  type TaskPatch,
  type TodoTask,
} from './Tododata.ts'

type View = 'board' | 'list'

interface Filters {
  q: string
  assignee: 'all' | string
  status: 'all' | StatusId
  priority: 'all' | Priority
  label: 'all' | string
}

const selectSx = { minWidth: 170, bgcolor: '#fff' }

function ToDo() {
  const [view, setView] = useState<View>('board')
  const [tasks, setTasks] = useState<TodoTask[]>([])
  const [filters, setFilters] = useState<Filters>({ q: '', assignee: 'all', status: 'all', priority: 'all', label: 'all' })
  const [openTaskId, setOpenTaskId] = useState<string | null>(null)
  const [createStatus, setCreateStatus] = useState<StatusId | null>(null) // non-null = create dialog open
  const [toast, setToast] = useState<string | null>(null)
  const [toastSev, setToastSev] = useState<'success' | 'error'>('success')
  const [saving, setSaving] = useState(0) // number of saves in flight
  const [ready, setReady] = useState(false) // users + statuses loaded from the API

  useEffect(() => {
    Promise.all([loadUsers(), loadStatuses()])
      .then(() => loadTasks())
      .then((list) => {
        setTasks(list)
        setReady(true)
      })
  }, [])

  const setFilter = <K extends keyof Filters>(key: K, value: Filters[K]) => setFilters((f) => ({ ...f, [key]: value }))

  const labels = useMemo(() => Array.from(new Set(tasks.flatMap((t) => t.labels))).sort(), [tasks])

  const filtered = useMemo(() => {
    const q = filters.q.trim().toLowerCase()
    return tasks.filter(
      (t) =>
        (!q || t.title.toLowerCase().includes(q) || t.key.toLowerCase().includes(q)) &&
        (filters.assignee === 'all' || t.assigneeIds.includes(filters.assignee)) &&
        (filters.status === 'all' || t.status === filters.status) &&
        (filters.priority === 'all' || t.priority === filters.priority) &&
        (filters.label === 'all' || t.labels.includes(filters.label)),
    )
  }, [tasks, filters])

  const openCount = tasks.filter((t) => !isFinalStatus(t.status) && !!STATUS_BY_ID[t.status]).length
  const doneCount = tasks.filter((t) => isFinalStatus(t.status)).length
  const openTask = tasks.find((t) => t.id === openTaskId) ?? null

  // --- mutations (swap these for API calls later; each one maps to one endpoint) ---

  const notify = (msg: string, sev: 'success' | 'error' = 'success') => {
    setToastSev(sev)
    setToast(msg)
  }

  /**
   * Save one task through the APIs its changed fields need (details, status, checklist).
   * Resolves with the task as the server now has it, fetched by todoTaskId (not the whole list).
   * Throws if any call fails, so nothing changes on screen.
   */
  const saveOne = async (old: TodoTask, next: TodoTask, patch: TaskPatch): Promise<TodoTask> => {
    const touches = (keys: (keyof TaskPatch)[]) => keys.some((k) => k in patch)
    const calls: Promise<unknown>[] = []
    if (touches(DETAIL_KEYS)) calls.push(saveTaskDetails(next))
    if (touches(STATUS_KEYS)) calls.push(saveTaskStatus(next, assigneesChanged(old, next)))
    if (CHECKLIST_KEY in patch) calls.push(saveTaskChecklist(old, next))
    if (calls.length === 0) return next // comments and labels have no API yet: local only
    await Promise.all(calls)
    const fresh = await loadTask(old.id)
    // activity is loaded by the detail dialog from the activity API, so it is not read here
    return fresh ? { ...fresh, activity: next.activity, labels: next.labels } : next
  }

  /**
   * Every edit lands here (detail dialog, list status select, board moves).
   * The screen only changes after the API says it worked. Resolves true when everything saved.
   */
  const updateTasks = async (ids: string[], patch: TaskPatch): Promise<boolean> => {
    const before = tasks.filter((t) => ids.includes(t.id))
    // Changing the assignee is saved as a status change to REASSIGNED
    const reassignedId = STATUS_BY_ID['reassigned'] ? 'reassigned' : null
    const after = before.map((t) => {
      const p = { ...patch }
      if (p.assigneeId && p.assigneeId !== t.assigneeId && !p.status && reassignedId) p.status = reassignedId
      return applyPatch(t, p, CURRENT_USER_ID)
    })
    const effective: TaskPatch = after.some((t, i) => t.status !== before[i].status) ? { ...patch, status: after[0].status } : patch

    setSaving((n) => n + 1)
    const results = await Promise.allSettled(before.map((old, i) => saveOne(old, after[i], effective)))
    setSaving((n) => n - 1)

    const saved = results.flatMap((r) => (r.status === 'fulfilled' ? [r.value] : []))
    if (saved.length > 0) setTasks((prev) => prev.map((t) => saved.find((s) => s.id === t.id) ?? t))

    const failed = results.find((r) => r.status === 'rejected') as PromiseRejectedResult | undefined
    if (failed) {
      notify(failed.reason?.response?.data?.message || failed.reason?.message || 'Could not save the change', 'error')
      return false
    }
    if (ids.length > 1) notify(`Updated ${ids.length} tasks`)
    return true
  }

  /** Board drag and drop: a new column is saved first, then the card moves; reordering in a column is local. */
  const moveCard = async (id: string, to: string, beforeId: string | null) => {
    const old = tasks.find((t) => t.id === id)
    if (!old) return
    if (old.status === to) {
      setTasks((prev) => moveTask(prev, id, to, beforeId, CURRENT_USER_ID))
      return
    }
    if (!(await updateTasks([id], { status: to }))) return
    // saved: put the card where it was dropped
    setTasks((prev) => {
      const card = prev.find((t) => t.id === id)
      if (!card) return prev
      const rest = prev.filter((t) => t.id !== id)
      const at = beforeId ? rest.findIndex((t) => t.id === beforeId) : -1
      return at < 0 ? [...rest, card] : [...rest.slice(0, at), card, ...rest.slice(at)]
    })
  }

  const deleteTask = async (id: string) => {
    const t = tasks.find((x) => x.id === id)
    if (!t) return
    try {
      await deleteTodoTask(t)
      setTasks((prev) => prev.filter((x) => x.id !== id))
      setOpenTaskId(null)
      notify(`${t.key} deleted`)
    } catch (error: any) {
      notify(error?.response?.data?.message || error?.message || 'Could not delete the task', 'error')
    }
  }

  /** The dialog has already saved the task through the API: reload the list so it shows up. */
  const createTask = async (_input: NewTaskInput, createAnother: boolean) => {
    setTasks(await loadTasks())
    notify('Task created')
    if (!createAnother) setCreateStatus(null)
  }

  const handleOpen = (task: TodoTask) => setOpenTaskId(task.id)
  const handleCreate = (status: StatusId = defaultStatusId()) => setCreateStatus(status)

  // if (!ready) return <Box className="p-3 m-3">Loading…</Box>
  if (!ready) return <></>

  return (
    <Box sx={{ borderRadius: '10px' }} className="p-3 m-3 bg-white">
      <Typography variant="h3" className="text-center" sx={{ fontWeight: 300 }}>
        Team Tasks
      </Typography>
      <Typography className="text-center" sx={{ mt: 1, fontSize: 14, color: '#666' }}>
        {openCount} open · {doneCount} closed
      </Typography>
      <Divider className="mt-3" sx={{ borderColor: PRIMARY }} />

      {saving > 0 && <LinearProgress aria-label="Saving" sx={{ mt: 1, bgcolor: '#E6E3D3', '& .MuiLinearProgress-bar': { bgcolor: PRIMARY } }} />}

      {/* Toolbar */}
      <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2, my: 3 }}>
        <TextField
          size="small"
          placeholder="Search tasks"
          value={filters.q}
          onChange={(e) => setFilter('q', e.target.value)}
          sx={{ width: 260, bgcolor: '#fff' }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />

        {/* Users: dropdown select */}
        <TextField select size="small" label="Assignee" value={filters.assignee} onChange={(e) => setFilter('assignee', e.target.value)} sx={selectSx}>
          <MenuItem value="all">Everyone</MenuItem>
          {USERS.map((u) => (
            <MenuItem key={u.id} value={u.id}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <UserAvatar user={u} size={22} />
                {u.name}
              </Box>
            </MenuItem>
          ))}
        </TextField>

        {view === 'list' && (
          <TextField select size="small" label="Status" value={filters.status} onChange={(e) => setFilter('status', e.target.value as Filters['status'])} sx={selectSx}>
            <MenuItem value="all">All statuses</MenuItem>
            {STATUSES.map((s) => (
              <MenuItem key={s.id} value={s.id}>
                {s.label}
              </MenuItem>
            ))}
          </TextField>
        )}

        <TextField select size="small" label="Priority" value={filters.priority} onChange={(e) => setFilter('priority', e.target.value as Filters['priority'])} sx={selectSx}>
          <MenuItem value="all">All priorities</MenuItem>
          {(Object.keys(PRIORITIES) as Priority[]).map((p) => (
            <MenuItem key={p} value={p}>
              {PRIORITIES[p].label}
            </MenuItem>
          ))}
        </TextField>

        {/* {view === 'board' && (
          <TextField select size="small" label="Label" value={filters.label} onChange={(e) => setFilter('label', e.target.value)} sx={selectSx}>
            <MenuItem value="all">All labels</MenuItem>
            {labels.map((l) => (
              <MenuItem key={l} value={l}>
                {l}
              </MenuItem>
            ))}
          </TextField>
        )} */}

        <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <ToggleButtonGroup
            exclusive
            size="small"
            value={view}
            onChange={(_, v: View | null) => v && setView(v)}
            aria-label="View"
            sx={{ bgcolor: '#55533C2A', '& .MuiToggleButton-root': { textTransform: 'none', border: 0, px: 1.5, gap: 0.75, color: '#55533C' }, '& .Mui-selected': { bgcolor: '#55533C !important', fontWeight: 700, color: '#fff !important' } }}
          >
            <ToggleButton value="board">
              <ViewKanbanOutlinedIcon fontSize="small" /> Board
            </ToggleButton>
            <ToggleButton value="list">
              <FormatListBulletedIcon fontSize="small" /> List
            </ToggleButton>
          </ToggleButtonGroup>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => handleCreate()}
            sx={{ bgcolor: PRIMARY, textTransform: 'none', fontWeight: 700, height: 40, '&:hover': { bgcolor: '#5C5A3B' } }}
          >
            New task
          </Button>
        </Box>
      </Box>

      {view === 'board' ? (
        <TaskBoard
          tasks={filtered}
          onMove={moveCard}
          onOpen={handleOpen}
          onCreate={handleCreate}
        />
      ) : (
        <TaskList tasks={filtered} onUpdate={updateTasks} onOpen={handleOpen} />
      )}

      {/* Task detail */}
      {openTask && (
        <TaskDetailDialog
          key={openTask.id}
          task={openTask}
          labelOptions={labels}
          onClose={() => setOpenTaskId(null)}
          onUpdate={(patch) => updateTasks([openTask.id], patch)}
          onDelete={() => deleteTask(openTask.id)}
        />
      )}

      {/* Create task */}
      {createStatus && (
        <CreateTaskDialog
          defaultStatus={createStatus}
          labelOptions={labels}
          onClose={() => setCreateStatus(null)}
          onSubmit={createTask}
        />
      )}

      <Snackbar open={!!toast} autoHideDuration={3000} onClose={() => setToast(null)} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert onClose={() => setToast(null)} severity={toastSev} variant="filled" sx={toastSev === 'success' ? { bgcolor: '#5C5A3B' } : undefined}>
          {toast}
        </Alert>
      </Snackbar>
    </Box>
  )
}

export default ToDo